var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#434343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-200v-60h80v-304q0-33 8.25-65T273-690l45 45q-9 19-13.5 39.46T300-564v304h319L75-805l42-42 726 727-42 42-122-122H160Zm560-129-60-60v-175q0-75-52.5-127.5T480-744q-35.14 0-67.57 13Q380-718 356-693l-46-45q23-23 50.5-38t59.5-22v-22q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v22q81 17 130.5 83.5T720-564v235Zm-260-91Zm20 340q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Zm28-461Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOff);
export default __webpack_public_path__ + "static/media/notification_off.92081e0bd4b3f7c2f0fcc2455822ad64.svg";
export { ForwardRef as ReactComponent };